/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetOffersHistoryExistsRequest,
  TGetOffersHistoryExistsModel,
  IMappers,
  TGetOffersHistoryExistsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOffersHistoryExistsResponse } from '../../entities/offers_history_exists/OffersHistoryExistsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOffersHistoryExistsModel(
  parameters: IGetOffersHistoryExistsRequest,
): TGetOffersHistoryExistsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v1/get-offers-history-exists/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetOffersHistoryExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOffersHistoryExistsRequest;
}

export async function fetchGetOffersHistoryExists<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOffersHistoryExistsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOffersHistoryExistsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOffersHistoryExistsModel(parameters),
    config,
  )) as FetchResponse<TGetOffersHistoryExistsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOffersHistoryExistsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOffersHistoryExistsResponse>;
}
